import { AcceptedPaymentMethod } from './PaymentCardOption.interfaces';

export const RADIO_SET_NAME = 'cards';

export const CARD_LOGOS: Record<AcceptedPaymentMethod, string> = {
  amex: '/images/american-express-logo.svg',
  mastercard: '/images/mastercard-logo.svg',
  visa: '/images/visa-logo.svg',
};
